import { useState } from "react";
import classNames from "classnames";

import { GameProcess } from "./GameProcess/GameProcess";
import { FailedReason } from "./FailedReason/FailedReason";
import { TeamInfo } from "./TeamInfo/TeamInfo";
import { ChangeEnergy } from "./ChangeEnergy/ChangeEnergy";

import ss from "./GameModal.module.css";

// modal type: game_process, team_info, adjust_energy, failed_reason
export const GameModal = (props) => {
  const { visible, onClose, onConfirm, type } = props;
  const [isClosing, setIsClosing] = useState(false);
  if (!visible) return null;

  const closeModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose?.();
      setIsClosing(false);
    }, 600);
  };

  return (
    <div className={classNames(ss.maskBg, isClosing && ss.fadeOut)}>
      <div className={classNames(ss.modal, isClosing && ss.zoomOut)}>
        <div className={ss.close} onClick={closeModal}></div>
        <div className={ss.title}></div>
        <div className={ss.content}>
          {type === "game_process" && <GameProcess />}
          {type === "failed_reason" && (
            <FailedReason
              onClose={closeModal}
              onConfirm={(reason) => {
                onConfirm?.(reason);
                closeModal();
              }}
            />
          )}
          {type === "team_info" && <TeamInfo />}
          {type === "change_energy" && (
            <ChangeEnergy
              onClose={closeModal}
              onConfirm={(value) => {
                onConfirm?.(value);
                closeModal();
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
